import { render } from "./DogFitness.vue?vue&type=template&id=5b334e24"
import script from "./DogFitness.vue?vue&type=script&lang=js"
export * from "./DogFitness.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./DogFitness.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "C:\\Users\\antho\\Documents\\Projects\\ynforma-website\\ynforma-website-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__